import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useActiveSession } from '../session';

interface Props extends RouteProps {
  redirectLoggedTo: string;
}

const GuestRoute: React.FC<Props> = ({ redirectLoggedTo, ...otherProps }) => {
  const { isLogged, isChecked } = useActiveSession();

  if (isLogged && isChecked) {
    return <Redirect to={redirectLoggedTo} />;
  }

  return <Route {...otherProps} />;
};

export default GuestRoute;
